/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Charges/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import ActionsAction from './ActionsAction/index'
import AddAction from './AddAction/index'
import Content from './Content/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import Location from './Location/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Charges({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Charges"
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<div
  data-testid="Charges.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-Z2eAcdw': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Charges.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-2-Z2eAcdw': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-Z2eAcdw': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Charges.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 text="Charges"
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="medium"
 marginTop={dtSpaceXs}
 color={dtColorsNeutral500}
 text="Administer charges."
/>
</div>
<div
  data-testid="Charges.Vertical:2"
  data-view-path={viewPath}
 style={{'--mt-4-Z2eAcdw': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical2}`}
>
<div
  data-testid="Charges.Horizontal:1"
  data-view-path={viewPath}
 style={{'--pl-2-Z2eAcdw': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-Z2eAcdw': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Horizontal1}`}
>
<Location
  viewPath={`${viewPath}/Location`}
/>
</div>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
/>
<div
  data-testid="Charges.Vertical:3"
  data-view-path={viewPath}
 style={{'--pl-2-Z2eAcdw': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-3-Z2eAcdw': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pt-1-Z2eAcdw': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical3}`}
>
<div
  data-testid="Charges.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<ActionsAction
  viewPath={`${viewPath}/ActionsAction`}
/>
<AddAction
  viewPath={`${viewPath}/AddAction`}
/>
</div>
<Content
  viewPath={`${viewPath}/Content`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}